import { useCallback, useState } from 'react';
import { DropdownMenu } from 'radix-ui';
import { useReduxState } from 'hooks';
import { TextInput } from 'components/common/form/common';

import { useFiltersContext, useFiltersDispatch } from './FilterContext';
import { RequireAllToggle } from '.';

interface Props {
  field: string;
  filterId: string;
  initialSwitchValue: boolean;
  onSearch: (search: string) => void;
  searchActive: boolean;
  switchActive: boolean;
}

const FilterHeader = ({
  field,
  filterId,
  initialSwitchValue,
  onSearch,
  searchActive = false,
  switchActive = false
}: Props) => {
  const { state } = useFiltersContext();

  const filterDispatch = useFiltersDispatch();

  const { messages, theme } = useReduxState();

  const [searchValue, setSearchValue] = useState('');

  const handleSearch: React.ChangeEventHandler<HTMLInputElement> = (ev) => {
    const search = ev.target.value;
    onSearch(search);
    setSearchValue(search);

    setTimeout(() => ev.target.focus(), 0);
  };

  const handleSwitchChange = () => {
    const newState = { ...(state?.[filterId] || {}) };
    if (!initialSwitchValue && !newState.presentInAll?.[field]) {
      newState.presentInAll = {
        ...(newState.presentInAll || {}),
        [field]: true
      };

      filterDispatch({ type: 'updateState', state: newState, filterId });
    } else {
      newState.presentInAll = { ...(newState.presentInAll || {}) };
      delete newState.presentInAll[field];
      if (Object.keys(newState.presentInAll).length === 0) {
        delete newState.presentInAll;
      }

      filterDispatch({ type: 'updateState', state: newState, filterId });
    }
  };

  const refCallback = useCallback(() => onSearch(''), []);

  return !searchActive && !switchActive ? null : (
    <div className="filter-header" ref={refCallback}>
      {searchActive ? (
        <TextInput
          onChange={handleSearch}
          placeholder={`${messages.commonSearch}...`}
          value={searchValue}
        />
      ) : null}

      {switchActive ? (
        <DropdownMenu.Item
          asChild={true}
          onClick={(ev) => ev.preventDefault()}
          onPointerMove={(ev) => ev.preventDefault()}
          onPointerLeave={(ev) => ev.preventDefault()}
        >
          <RequireAllToggle
            handleToggle={handleSwitchChange}
            isActive={initialSwitchValue}
            style={{ marginTop: 10 }}
          />
        </DropdownMenu.Item>
      ) : null}

      <style jsx>{`
        .filter-header {
          border-bottom: 1px solid ${theme.lightGreyDarkActive};
          border-radius: ${theme.dropdownBorderRadius}
            ${theme.dropdownBorderRadius} 0 0;
          background-color: white;
          padding: 10px 12px;
          position: sticky;
          top: 0;
          z-index: 2;
        }
      `}</style>
    </div>
  );
};

export default FilterHeader;
